import React from 'react'
import { useStyles } from './OfferAccepted.styles'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Typography } from '@mui/material'

export const OfferAccepted: React.FC = () => {
  const { classes } = useStyles()
  return (
    <div className={classes.parent} data-testid="offer-accepted-div">
      <CheckCircleOutlineIcon
        className={classes.icon}
        data-testid="offer-accepted-icon"
      />
      <Typography
        className={classes.offerAcceptedTitle}
        data-testid="offer-accepted-title"
      >
        Offer accepted
      </Typography>
      <Typography
        className={classes.offerAcceptedContent}
        data-testid="offer-accepted-content"
      >
        Congratulations,the private offer is accepted. Please connect with the
        buyer to onboard them on your platform.
      </Typography>
    </div>
  )
}
